import axios from 'axios'

// 让请求在浏览器中允许跨域携带cookie
// axios.defaults.withCredentials = true

// 使用自定义配置新建一个 axios 实例

const service = axios.create({
    // 基础的请求地址
    baseURL: 'https://wapi.gongbocoins.com/', //正式环境
    // baseURL: 'https://testxc.gongbocoins.com/',
    // dev: 'http://testjapi.gongbocoins.com/'
    // pro: 'https://wapi.gongbocoins.com'
    // 军:  'http://192.168.2.134:8080/'
    timeout: 10000 // 请求超时时间 1000ms = 1s，更改为10s
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        // 在请求发送之前做一些处理
        config.headers['lang'] = localStorage.getItem('language') || ((navigator.language == 'zh-CN' || navigator.language == 'en') ? navigator.language : 'zh-CN')
        // const token = util.cookies.get('token');
        // // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
        // if (token != undefined && token != 'undefined' && token != '') {
        //     config.headers['token'] = token
        // }
        return config;
    },
    error => {
        // 发送失败
        Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    response => {
        // dataAxios 是 axios 返回数据中的 data
        const dataAxios = response.data;
        // 这个状态码是和后端约定的
        const { code } = dataAxios;
        return dataAxios;
        // if (code == undefined || typeof(code) == 'undefined') {
        //     // 如果没有 code 代表这不是项目后端开发的接口
        //     return dataAxios;
        // } else {

        // }
    },
    error => {

    }
);

export default service;


// WEBPACK FOOTER //
// ./src/api/index.js